module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[94]337.e1f9672.woff2";